import React from 'react';
import ReactDOM from 'react-dom';
import 'antd-mobile/dist/antd-mobile.css';
import './assets/scss/common.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import wx from 'weixin-js-sdk';
// import Vconsole from 'vconsole'
// 挂载在window
window.$wx = wx;

// // 调试工具
// const vConsole = new Vconsole();
// export default vConsole;

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
